import * as angular from "angular";

function sortable() {
    return {
        template: require('./Sortable.html'),
        restrict: 'A',
        transclude: true,
        scope: { sortableField: '@', sortableVar:'=sortable'},
    };
}

export default angular.module('directives.sortable', [])
    .directive('sortable', sortable)
    .name;

